import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Badge,
  Button,
  Collapse,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  addSelectedFilter,
  deleteSelectedFilter,
} from '../../actions/Files';

import { slugify } from '../../helpers';

import FiltersResetButton from './FiltersResetButton';

class FiltersFileStatuses extends Component {
  constructor(props) {
    super(props);

    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  getStatus(statusId) {
    const { statuses } = this.props;
    const status = statuses.find(s => (s.id === parseInt(statusId)));
    if (status) {
      return status;
    }

    return {
      name: '',
    };
  }

  handleChangeFilter(e) {
    const {
      checked,
      value,
    } = e.target;
    const {
      intl,
      filters,
      handleChangeFilters,
      addFilter,
      removeFilter,
    } = this.props;
    let { statuses: newSelected } = filters;
    if (checked) {
      newSelected.push(`${value}`);
      addFilter({
        type: 'statuses',
        key: `${value}`,
        label: this.getStatus(value).name,
        title: intl.formatMessage({ defaultMessage: 'Status' }),
      });
    } else {
      newSelected = newSelected.filter(s => (`${s}` !== `${value}`));
      removeFilter('statuses', value);
    }
    handleChangeFilters({ statuses: newSelected });
  }

  handleReset() {
    const {
      handleChangeFilters,
      clearSelectedFilters,
    } = this.props;
    handleChangeFilters({ statuses: [] });
    clearSelectedFilters('statuses');
  }

  render() {
    const {
      intl,
      isOpen,
      availableFilters,
      filters,
      handleToggleFilter,
      prefix,
    } = this.props;
    const selected = filters.statuses;

    if (availableFilters.length === 0) {
      return null;
    }

    return (
      <div className="files-filter file-status-filter">
        <div className="filter-header">
          <Button onClick={handleToggleFilter} className="filter-title">
            <i className={`fal fa-angle-${isOpen ? 'up' : 'down'}`} />
            <span>{intl.formatMessage({ defaultMessage: 'File status' })}</span>
            {' '}
            {selected.length > 0 && (
              <Badge color="primary">
                {selected.length}
              </Badge>
            )}
          </Button>
          {selected.length > 0 && (
            <FiltersResetButton
              handleReset={this.handleReset}
            />
          )}
        </div>
        <Collapse
          isOpen={isOpen}
          className="filter-body"
        >
          <div className="filter-form file-status-filter-form">
            {availableFilters.map(ft => (
              <FormGroup key={`filestatus-${slugify(ft.key)}`}>
                <Label for={`${prefix}checkFileStatus-${slugify(ft.key)}`} check>
                  <Input
                    type="checkbox"
                    name="fileType"
                    id={`${prefix}checkFileStatus-${slugify(ft.key)}`}
                    className="input-check check-s"
                    value={ft.key}
                    checked={selected.find(s => (parseInt(s) === ft.key)) || false}
                    onChange={this.handleChangeFilter}
                  />
                  {' '}
                  <span>
                    <i className="file-status" style={{ backgroundColor: this.getStatus(ft.key).color }} />
                    {' '}
                    {this.getStatus(ft.key).name}
                  </span>
                </Label>
              </FormGroup>
            ))}
          </div>
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  statuses: state.Files.statuses,
  filters: props.customFilters || state.Files.filters,
});

const mapDispatchToProps = (dispatch, props) => ({
  addFilter: props.customAddFilter || ((filter) => {
    dispatch(addSelectedFilter(filter));
  }),
  removeFilter: props.customRemoveFilter || ((filterType, filterKey) => {
    dispatch(deleteSelectedFilter(filterType, filterKey));
  }),
  clearSelectedFilters: props.customClearSelectedFilters || ((filterType) => {
    dispatch(deleteSelectedFilter(filterType, null));
  }),
});

FiltersFileStatuses.propTypes = {
  intl: PropTypes.object.isRequired,
  statuses: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired,
  addFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  clearSelectedFilters: PropTypes.func.isRequired,
  availableFilters: PropTypes.array.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleChangeFilters: PropTypes.func.isRequired,
  handleToggleFilter: PropTypes.func.isRequired,
  prefix: PropTypes.string,
};

FiltersFileStatuses.defaultProps = {
  prefix: '',
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(FiltersFileStatuses));
